// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__lIkFI","title":"Header_title__29ce2","left":"Header_left__2bnCM","clinicName":"Header_clinicName__u0nxb"};